import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Card, Button, Form, Table, Loader, Label} from 'semantic-ui-react';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {paths} from '../../../common/dictionaries/urls';
import {Actions} from '../../../common/actions';
import {CAMPAIGN_STATUS} from '../../constants';
import CampaignTable from './CampaignTable';
import SearchForm from './SearchForm';
import './styles.scss';

class CampaignList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'status': 'TODOS',
      'selectedStatus': 'TODOS',
      'countRows': 0,
    };
  }

  componentDidMount() {
    if (!hasAccessPermission(this.props.permissions, resources.MaintainCampaign, scopes.See)) {
      this.props.navigateTo(paths.AccessDenied);
    }
    this.handleSearch();
  }

  componentWillUnmount() {
    this.props.clearCampaignsList();
  }

  onNavigate = () => {
    this.props.navigateTo(paths.CreateCampaign);
  }

  handleSearch = () => {
    const {status} = this.state;
    this.props.fetchCampaignList({status});
  };

  handleChange = (field, value) => {
    this.setState({
      [field]: value,
    });
  };

  renderLoader() {
    return (
      <Table striped className='toyota-grid'>
        <Table.Body>
          <Table.Row>
            <Table.Cell colSpan='100%'>
              <Loader active inline='centered' content='Ejecutando' />
            </Table.Cell>
          </Table.Row>
        </Table.Body>
      </Table>
    );
  }

  render() {
    const {campaignList, loading, isUserTde} = this.props;
    const {countRows} = this.state;

    return (
      <div className='campaign-container'>
        <Card raised fluid>
          <div className='title-bar'>
            <div className='title'>
              <h2>Consulta de Campañas</h2>
              <Label className='campaign-total' color='red' size='large'>
                Total campañas
                <Label.Detail>{countRows}</Label.Detail>
              </Label>
              {isUserTde && (
                <div className='title-bar-actions twc-title-bar-actions'>
                  <Button
                    primary
                    className='toyota-primary'
                    disabled={loading}
                    onClick={this.onNavigate}
                  >
                    Añadir Campaña
                  </Button>
                </div>
              )}
            </div>
          </div>
        </Card>
        <Card raised fluid>
          <div className='search-container'>
            <Form>
              <label className='invoice-b-10'>Búsqueda de campañas</label>
              <Form.Group widths='equal'>
                <SearchForm
                  {...this.state}
                  statusSelect={CAMPAIGN_STATUS}
                  handleChange={this.handleChange}
                />
                <div className='twc-btn-search'>
                  <Button
                    disabled={loading}
                    onClick={this.handleSearch}
                    type='submit'
                    color='green'
                  >
                    BUSCAR
                  </Button>
                </div>
              </Form.Group>
            </Form>
          </div>
        </Card>
        <Card raised fluid className='campaign-table'>
          {loading ? (
            this.renderLoader()
          ) : (
            <CampaignTable
              dataTable={campaignList}
              countRows={countRows}
              isUserTde={isUserTde}
              handleChange={this.handleChange}
            />
          )}
        </Card>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'permissions': state.session.permissions,
    'isUserTde': state.session.isUserFromTDE,
    'campaignList': state.campaignList.list,
    'loading': state.campaignList.loading,
  };
};

const {
  withRouter,
  navigateTo,
  fetchCampaignList,
  clearCampaignsList,
} = Actions;

const mapDispatchToProps = {
  navigateTo,
  fetchCampaignList,
  clearCampaignsList,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CampaignList));
